// Compact weather chip — single day. Used on dispatch job cards and inline.
import { weatherStyles, weatherIcon } from "@/lib/weather";

const UnknownChip = () => {
  const S = weatherStyles("unknown");
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider border ${S.badge}`}
      title="No site address — add coordinates to see forecast"
      data-testid="weather-chip-unknown"
    >
      <S.icon className="w-3 h-3" /> No fcast
    </span>
  );
};

export default function WeatherChip({ day, compact = false }) {
  if (!day) return <UnknownChip />;
  const S = weatherStyles(day.severity);
  const Icon = weatherIcon(day);
  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider border ${S.badge}`}
        title={`${day.label} · ${(day.rain_mm || 0).toFixed(1)}mm rain · ${day.rain_prob || 0}% · wind ${(day.wind_kmh || 0).toFixed(0)}km/h`}
        data-testid={`weather-chip-${day.severity}`}
      >
        <Icon className="w-3 h-3" />
        {(day.rain_mm || 0) > 0 ? `${(day.rain_mm || 0).toFixed(1)}mm` : day.label}
      </span>
    );
  }
  return (
    <div
      className={`inline-flex items-center gap-2 px-2 py-1 border ${S.cell}`}
      data-testid={`weather-chip-full-${day.severity}`}
    >
      <Icon className="w-4 h-4 shrink-0" />
      <div className="text-[10px] leading-tight">
        <div className="font-bold uppercase tracking-wider">{day.label}</div>
        <div className="font-mono text-[9px] opacity-80">
          {(day.rain_mm || 0).toFixed(1)}mm · {day.rain_prob || 0}% · {(day.wind_kmh || 0).toFixed(0)}km/h
        </div>
      </div>
    </div>
  );
}
